import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import DistributorManagementViewModel from "../../../../viewModels/timeCharges/distributors/distributorManagement/distributorManagementViewModel";
import ListView from "../../../common/list";
import { formatAmount, formatNumber } from "../../../../utils/localizations";

const DistributorManagementView: ViewComponent<DistributorManagementViewModel> = observer(({ vm }) => {
  return (
    <ListView
      vm={vm}
      columns={[
        { property: "name", title: vm.translateAttribute("name") },
        { property: "shortName", title: vm.translateAttribute("shortName") },
        {
          property: "type",
          title: vm.translateAttribute("type"),
          valueFormatter: props => (props.item.type ? vm.translateTypeEnum(props.item.type) : ""),
        },
        {
          property: "status",
          title: vm.translateAttribute("status"),
          valueFormatter: props => (props.item.status ? vm.translateStatusEnum(props.item.status) : ""),
        },
        { property: "dueDays", title: vm.translateAttribute("dueDays") },
        {
          property: "safeExposure",
          title: vm.translateAttribute("safeExposure"),
          valueFormatter: props => formatAmount(props.item.safeExposure),
        },
        {
          property: "creditExposureWarningPercentage",
          title: vm.translateAttribute("creditExposureWarningPercentage"),
          valueFormatter: props => `${formatNumber(props.item.creditExposureWarningPercentage)} %`,
        },
        { property: "email", title: vm.translateAttribute("email") },
      ]}
    />
  );
});

registerView(DistributorManagementView, DistributorManagementViewModel);
